import { render } from "./BoletosModuloControl.vue?vue&type=template&id=9d69610c&scoped=true"
import script from "./BoletosModuloControl.vue?vue&type=script&lang=js"
export * from "./BoletosModuloControl.vue?vue&type=script&lang=js"

import "./BoletosModuloControl.vue?vue&type=style&index=0&id=9d69610c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d69610c"]])

export default __exports__